export default __webpack_public_path__ + "static/media/normal-bus.9aa4ddce.svg";